import React, { useEffect, useRef, useState } from 'react';
import { bool } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Popover, PopoverAnchor } from '@fiverr-private/popover';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { ChevronDownIcon, ChevronUpIcon } from '@fiverr-private/icons';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { reportContactSellerOptionsClick } from '../../../utils/contactSeller';
import { fibMigrationFlow, FibTriggers } from '../../../utils/fibMigrationFlow';
import { trackContactMeClickEvent } from '../../../utils/gtmTracking/gtmTracking';
import PopoverContent from './PopoverContent';
import { GradientButtonWithOptions } from './GradientButtonWithOptions';

const ContactSellerOptions = ({ customOrderEligible }) => {
    const { biEvents, seller, floatingChatData } = useGigPageContext();
    const contactSellerButtonRef = useRef();
    const [isOpen, setIsOpen] = useState(false);

    const { isAgency } = seller;
    const ctaTitle = isAgency
        ? `gig_page_perseus.contact_seller.title_agency`
        : `gig_page_perseus.contact_seller.title`;

    useEffect(() => {
        handlePersistedFibMigrationTriggers(contactSellerButtonRef.current);
    }, [contactSellerButtonRef]);

    const onOpen = async () => {
        setIsOpen(true);
        reportContactSellerOptionsClick(biEvents);
        trackContactMeClickEvent();
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const onOpenChanged = (isOpen) => isOpen ? onOpen() : onClose();

    const handlePersistedFibMigrationTriggers = (buttonEl) => {
        if (!buttonEl) {
            return;
        }
        const isAskQuestionTriggerPersisted = fibMigrationFlow.isTriggerIdPersisted(FibTriggers.Contact);
        const isGetQuoteTriggerPersisted = fibMigrationFlow.isTriggerIdPersisted(FibTriggers.GetQuote);

        if (isAskQuestionTriggerPersisted || isGetQuoteTriggerPersisted) {
            // README: We have to open dropdown for run logic inside options
            buttonEl.dispatchEvent(new Event('click', { bubbles: true }));
        }
    };

    return (
        <div className="contact-seller-options-wrapper">
            <Popover appendToBody={false} isOpen={isOpen} onOpenChanged={onOpenChanged}>
                <PopoverAnchor fullWidth>
                    <GradientButtonWithOptions withBorder={floatingChatData?.isEligible} ref={contactSellerButtonRef}>
                        <Typography color="grey_1100">
                            <I18n k={ctaTitle} />
                        </Typography>
                        <Container marginLeft="2">
                            {isOpen ? (
                                <ChevronUpIcon size="10" color="grey_1100" fill={{ hover: 'white' }} />
                            ) : (
                                <ChevronDownIcon size="10" color="grey_1100" fill={{ hover: 'white' }} />
                            )}
                        </Container>
                    </GradientButtonWithOptions>
                </PopoverAnchor>
                <PopoverContent customOrderEligible={customOrderEligible} />
            </Popover>
        </div>
    );
};

ContactSellerOptions.propTypes = {
    customOrderEligible: bool,
};

export default ContactSellerOptions;
